import { useState } from 'react';
import toast from 'react-hot-toast';

// Get API URL from environment or use the production URL
const API_BASE = process.env.REACT_APP_API_URL || 'https://inteliheads.in/api';

export const useImageUpload = () => {
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState('');

  const validateImage = (file) => {
    if (!file) {
      return { valid: false, error: 'No file selected' };
    }
    if (!file.type.startsWith('image/')) {
      return { valid: false, error: 'Please upload an image file (JPEG, PNG, GIF, WEBP)' };
    }
    if (file.size > 5 * 1024 * 1024) {
      return { valid: false, error: 'File size must be less than 5MB' };
    }
    return { valid: true, error: null };
  };

  const handleImageChange = (file) => {
    const validation = validateImage(file);
    if (!validation.valid) {
      toast.error(validation.error);
      return false;
    }
    setImageFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
    return true;
  };

  const uploadImage = async () => {
    if (!imageFile) return '';
    setUploading(true);
    const formData = new FormData();
    formData.append('image', imageFile);
    
    try {
      const token = localStorage.getItem('adminToken');
      
      if (!token) {
        toast.error('Please login again');
        return '';
      }

      // Only use S3 upload - no local fallback
      const response = await fetch(`${API_BASE}/upload/s3/image`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success('Image uploaded successfully to S3');
        return result.data.url;
      } else {
        toast.error(result.message || 'Upload failed');
        return '';
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Failed to upload image. Please check your connection.');
      return '';
    } finally {
      setUploading(false);
      setImageFile(null);
      // Clear preview after a delay
      setTimeout(() => setPreview(''), 500);
    }
  };

  return { 
    imageFile, 
    uploading, 
    preview, 
    handleImageChange, 
    uploadImage, 
    setPreview 
  };
};